module.exports = __webpack_public_path__ + "static/media/ali_active.de06f937.svg";